import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../authentication/auth.service';
import { ConstantService, UserRoles } from '../../../services/common/constant.service';
import { EnrollmentOptionsService } from '../../../services/common/enrollment-options';
import { EnrollmentInputModel } from '../models/enrollmentinput.model';

import { EnrollmentComponent } from '../enrollment.component';

@Component({
  selector: 'app-enrollment-container',
  template: `
    @if (options(); as enrollmentOptions) {
      <div class="bs-legacy">
        <app-enrollment
          [options]="enrollmentOptions"
          [hideSaveButton]="hideSaveButton"
          [useExternalToast]="useExternalToast"
          (backPressedEvent)="backPressed()"
          (callback)="savedEnrollment()"
          (saveStateChanged)="saveStateChanged.emit($event)"
          (saveFailed)="saveFailed.emit($event)"
        />
      </div>
    }
  `,
  imports: [EnrollmentComponent],
})
export class EnrollmentContainerComponent implements OnInit {
  private authService = inject(AuthService);
  private constantService = inject(ConstantService);
  private activatedRoute = inject(ActivatedRoute);
  private enrollmentOptions = inject(EnrollmentOptionsService);

  @Input() disablePrimaryFactor: boolean;
  @Input() hidePrimaryFactor: boolean;
  @Input() skipPasswordPresence: boolean;
  @Input() onlyAwaitingEnrollment: boolean;
  @Input() isUserActive: boolean;
  @Input() userId: number;
  @Input() username: string;
  @Input() backButtonText: string = 'Button.Back';
  @Input() hideSaveButton = false;
  @Input() useExternalToast = false;

  @Output() backPressedEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() savedEnrollmentEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saveStateChanged = new EventEmitter<{ canSave: boolean; hasChanges: boolean }>();
  @Output() saveFailed = new EventEmitter<string | null>();

  @ViewChild(EnrollmentComponent) private enrollment?: EnrollmentComponent;

  orgId: number;
  orgMnemonic: string;

  options = signal<EnrollmentInputModel | null>(null);

  async ngOnInit(): Promise<void> {
    this.orgId = this.authService.organizationId;
    this.orgMnemonic = this.constantService.getSubdomain();

    let userType: string = 'user';
    if (this.activatedRoute.snapshot.params['userType']) {
      userType = this.constantService.decode(this.activatedRoute.snapshot.params['userType']);
    }

    const options = await this.enrollmentOptions.createOptions(
      this.orgId,
      this.orgMnemonic,
      this.userId,
      this.username,
      this.isUserActive,
      userType,
      this.disablePrimaryFactor,
      this.hidePrimaryFactor,
      false,
      false,
      false,
      false,
      this.skipPasswordPresence,
    );
    if (this.backPressedEvent.observed) {
      options.style.showBackButton = true;
      options.style.backButtonText = this.backButtonText;
    }
    this.options.set(options);
  }

  backPressed() {
    this.backPressedEvent.emit();
  }

  savedEnrollment() {
    this.savedEnrollmentEvent.emit();
  }

  save(): void {
    this.enrollment?.save();
  }

  reload(): void {
    this.enrollment?.reload();
  }
}
